import React from "react";
import {FormaPagamentoIndexPage} from "@components/formaPagamento/pages/FormaPagamentoIndexPage.tsx";
import {FornecedoresPage} from '@components/fornecedores/pages/FornecedoresPage.tsx';
import {OrcamentoPage} from "@components/orcamento/pages/OrcamentoPage.tsx";
import {RecursoTransferenciaPage,} from '@components/recurso/pages/movimentacoes/RecursoTransferenciaPage.tsx';
import {SolicitacaoTipoPage} from '@components/solicitacoes/pages/tipos/SolicitacaoTipoPage.tsx';
import {SolicitacaoTiposPage} from '@components/solicitacoes/pages/tipos/SolicitacaoTiposPage.tsx';
import {NotificacoesPage} from '@components/usuario/notificacoes/pages/NotificacoesPage.tsx';
import {_Sitemap} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import {SolicitacaoPage} from "@components/solicitacoes/pages/solicitacoes/SolicitacaoPage.tsx";
import {OrcamentosPage} from '@pages/pendencias/Orcamentos/OrcamentosPage.tsx';
import {PageNotFound} from "@shared/PageNotFound.tsx";
import {Outlet, Route, Routes} from "react-router-dom";
import {DefaultLayout} from "@shared/DefaultLayout.tsx";
import {HomePage} from "@shared/HomePage.tsx";
import {GerenciamentoUsuariosPage} from "@components/seguranca/pages/GerenciamentoUsuariosPage.tsx";
import {SegurancaProvider} from "@contexts/SegurancaContext.tsx";
import {SolicitacoesIndexPage} from "@components/solicitacoes/pages/SolicitacoesIndexPage.tsx";
import {FornecedoresIndexPage} from "@components/fornecedores/pages/FornecedoresIndexPage.tsx";
import {FornecedorConsultaPage} from "@components/fornecedores/pages/FornecedorConsultaPage.tsx";
import {RecursoPage} from "@components/recurso/pages/RecursoPage.tsx";
import {RecursosIndexPage} from "@components/recurso/pages/old/RecursosIndexPage.tsx";
import {RecursosPage} from "@components/recurso/pages/RecursosPage.tsx";
import {SolicitacoesPage} from "@components/solicitacoes/pages/solicitacoes/SolicitacoesPage.tsx";
import {UsuarioPage} from "@components/contas/pages/UsuarioPage.tsx";
import {FornecedorPage} from "@components/fornecedores/pages/FornecedorPage.tsx";
import {ProdutoPage} from "@components/produtos/pages/ProdutoPage.tsx";
import {ProdutosIndexPage} from "@components/produtos/pages/ProdutosIndexPage.tsx";
import {ProdutosPage} from "@components/produtos/pages/ProdutosPage.tsx";
import {ProdutoCreateComponent} from "@components/produtos/pages/ProdutoCreateComponent.tsx";
import {ContratoPage} from "@components/contratos/pages/ContratoPage.tsx";
import {DashboardSolicitacoesPage} from "@components/dashboards/pages/DashboardSolicitacoesPage.tsx";
import {ContratosPage} from "@components/contratos/pages/ContratosPage.tsx";
import {RecursosMovimentacoesV2Page} from "@components/recurso/pages/movimentacoes/RecursosMovimentacoesV2Page.tsx";
import {ContaContabilRoutes} from "@shared/appRoutes/AppRoutes.ContasContabeis.tsx";
import {FlagsPage} from "@components/flags/pages/FlagsPage.tsx";
import {EmpresasRoutes} from "@shared/appRoutes/AppRoutes.Empresas.tsx";


export const AppRoutes = () => {
    return (
        <Routes key={1}>
            <Route path={""} element={<DefaultLayout/>} children={
                [
                    <Route index path={''} key={'index'} element={<HomePage/>}/>,
                    <Route path={'home'} key={'home'} element={<HomePage/>}/>,
                    <Route path={'seguranca'} key={'seguranca'} element={<SegurancaProvider/>}
                           children={
                               <Route path={'usuarios'} element={<GerenciamentoUsuariosPage/>}/>
                           }
                    />,
                    <>{ProdutoRoutes()}</>,
                    <>{SolicitacaoRoutes()}</>,
                    <>{FornecedoresRoutes()}</>,
                    <>{ContaContabilRoutes()}</>,
                    <>{FormaPagtoRoutes()}</>,
                    <>{OrcamentoRoutes()}</>,
                    <>{RecursoRoutes()}</>,
                    <>{UsuarioRoutes()}</>,
                    <>{NotificacoesRoutes()}</>,
                    <>{ContratoRoutes()}</>,
                    <>{DashboardRoutes()}</>,
                    <>{EmpresasRoutes()}</>]
            }/>
            <Route path={"*"} element={<DefaultLayout/>} children={[
                <Route path={'*'} element={<PageNotFound/>}/>,
            ]}>
            </Route>

        </Routes>
    );
};

const ProdutoRoutes = () => {
    return <Route path={'produtos'} key={'produtos'} element={<Outlet/>} children={[
        <Route path={'menu'} key={'produtos/menu'} element={<ProdutosIndexPage/>}/>,
        <Route path={'consulta'} key={'produtos/consulta'}
               element={<ProdutosPage/>}/>,
        <Route path={'novo'} key={'produtos/novo'}
               element={<ProdutoCreateComponent/>}/>,
        <Route path={'detalhes'} key={'produtos/detalhes'}
               element={<ProdutoPage/>}/>,
    ]}/>;
};
const UsuarioRoutes = () => {
    return <Route path={'usuarios'} key={'usuarios'} element={<Outlet/>} children={[
        <Route path={'menu'} key={'usuarios/menu'} element={<GerenciamentoUsuariosPage/>}/>,
        <Route path={'detalhes'} key={'usuarios/detalhes'}
               element={<UsuarioPage/>}/>,
    ]}/>;
};

const RecursoRoutes = () => {
    const {recurso} = _Sitemap;
    const {movimentacoes} = recurso.children;

    return (<Route path={recurso.url} key={recurso.url} element={<Outlet/>}
                   children={[
                       <Route path={recurso.children.menu.url} key={recurso.children.menu.fullUrl}
                              element={<RecursosIndexPage/>}/>,
                       <Route path={recurso.children.gerenciamento.url} key={recurso.children.gerenciamento.fullUrl}
                              element={<RecursosPage/>}/>,
                       <Route path={recurso.children.transferencias.url} key={recurso.children.transferencias.fullUrl}
                              element={<Outlet/>} children={[
                           <Route path={recurso.children.transferencias.children.lista.url}
                                  key={recurso.children.transferencias.children.lista.fullUrl}
                                  element={<>{/*TODO: IMPLEMENTAR*/}</>}/>,
                           <Route path={recurso.children.transferencias.children.detalhes.url}
                                  key={recurso.children.transferencias.children.detalhes.fullUrl}
                                  element={<RecursoTransferenciaPage/>}/>,
                       ]
                       }/>,
                       <Route path={recurso.children.detalhes.url} key={recurso.children.detalhes.fullUrl}
                              element={<RecursoPage/>}/>,
                       <Route path={movimentacoes.url} key={movimentacoes.fullUrl} element={<Outlet/>} children={[
                           <Route path={movimentacoes.children.lista.url} element={<RecursosMovimentacoesV2Page/>}
                                  key={movimentacoes.children.lista.fullUrl}/>
                       ]
                       }/>,
                   ]}
    />);
};

const OrcamentoRoutes = () => {
    const {children} = _Sitemap.orcamento

    return <Route path={'orcamento'} key={'orcamento'} element={<Outlet/>} children={[
        <Route path={'detalhes'} key={'orcamento/detalhes'}
               element={(<OrcamentoPage/>)}/>,
        <Route path={children.menu.url} key={children.menu.fullUrl}
               element={<OrcamentosPage overrides={{size: 'large'}}/>}/>,
        <Route path={children.lista.url} key={children.lista.fullUrl}
               element={<OrcamentosPage overrides={{size: 'large'}}/>}/>,
        <Route path={children.a_pagar.url} key={children.a_pagar.fullUrl}
               element={<OrcamentosPage filtros={{
                   isPago: 'false',
                   isCancelado: 'false',
                   isAutorizado: 'true',
                   isConfirmado: 'true'
               }} overrides={{size: 'large'}}/>}/>,
        <Route path={children.flags.url} key={children.flags.fullUrl}
               element={<FlagsPage filtros={{}}/>}/>
    ]}/>;
};

const SolicitacaoRoutes = () => {
    const {solicitacoes} = _Sitemap;

    return (<Route path={solicitacoes.url} key={solicitacoes.fullUrl}
                   element={<Outlet/>} children={[
        <Route path={solicitacoes.children.menu.url} key={solicitacoes.children.menu.fullUrl}
               element={<SolicitacoesIndexPage/>}/>,
        <Route path={solicitacoes.children.lista.children.detalhes.url}
               key={solicitacoes.children.lista.children.detalhes.fullUrl}
               element={<SolicitacaoPage/>}/>,
        <Route path={solicitacoes.children.lista.url} key={solicitacoes.children.lista.fullUrl}
               element={<SolicitacoesPage filtersProps={{
                   filters: {finalizado: 'false'},
                   setFilters: () => {
                   }
               }}/>}/>,
        <Route path={solicitacoes.children.tipos.url} key={solicitacoes.children.tipos.fullUrl}
               element={<Outlet/>} children={[
            <Route path={solicitacoes.children.tipos.children.lista.url}
                   key={solicitacoes.children.tipos.children.lista.fullUrl}
                   element={<SolicitacaoTiposPage/>}/>,
            <Route path={solicitacoes.children.tipos.children.detalhes.url}
                   key={solicitacoes.children.tipos.children.detalhes.fullUrl}
                   element={<SolicitacaoTipoPage/>}/>]
        }
        />,


    ]}/>);
};

const ContratoRoutes = () => {
    return <Route path={'contratos'} key={'contratos'} element={<Outlet/>}
                  children={[
                      <Route path={'menu'} key={'contratos/menu'} element={<ContratosPage/>}/>,
                      <Route path={'consulta'} key={'contratos/consulta'}
                             element={<ContratosPage/>}/>,
                      <Route path={'detalhes'} key={'contratos/detalhes'}
                             element={<ContratoPage/>}/>,
                  ]}/>;
}

const FormaPagtoRoutes = () => {
    return <Route path={'formasPagamento'} key={'formaPagamento'} element={<FormaPagamentoIndexPage/>}
                  children={[
                      <Route path={'menu'} key={'formaPagamento/menu'} element={<></>}/>,
                      <Route path={'novo'} key={'formaPagamento/novo'}
                             element={<FormaPagamentoIndexPage/>}/>,
                  ]}/>;
};

const FornecedoresRoutes = () => {
    const {fornecedores} = _Sitemap;

    return <Route path={fornecedores.url} key={'fornecedores'} element={<Outlet/>}
                  children={[
                      <Route path={'menu'} key={'fornecedores/menu'}
                             element={<FornecedoresIndexPage/>}/>,
                      <Route path={'consulta'} key={'fornecedores/consulta'}
                             element={<FornecedorConsultaPage/>}/>,
                      <Route path={fornecedores.children.detalhes.url} key={'fornecedores/detalhes'}
                             element={<FornecedorPage/>}/>,
                      <Route path={fornecedores.children.lista.url} key={'fornecedores/lista'}
                             element={<FornecedoresPage/>}/>,
                  ]}/>;
};

const NotificacoesRoutes = () => {
    const {notificacoes} = _Sitemap;

    return <Route
        path={notificacoes.url} key={notificacoes.fullUrl}
        element={<Outlet/>} children={[
        <Route path={notificacoes.children.minhas.url} key={notificacoes.children.minhas.fullUrl}
               element={<NotificacoesPage/>}/>,
    ]}/>;
};

const DashboardRoutes = () => {
    const {dashboard} = _Sitemap;
    return <Route path={dashboard.url} key={dashboard.fullUrl} element={<Outlet/>} children={[
        <Route path={dashboard.children.home.url} key={dashboard.children.home.fullUrl} element={<></>}/>,
        <Route path={dashboard.children.solicitacoes.url} key={dashboard.children.solicitacoes.fullUrl}
               element={<DashboardSolicitacoesPage/>}/>,
        <Route path={dashboard.children.recurso.url} key={dashboard.children.recurso.fullUrl} element={<></>}/>,
    ]}/>;
}